import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

function Navbar() {
    const { isAuthenticated, logout } = useAuth();
    const [expandedSections, setExpandedSections] = useState({
        news: false,
        tools: false
    });
    const [newsList, setNewsList] = useState([]);

    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        try {
            const response = await fetch('http://localhost:8080/api/news');
            if (!response.ok) {
                throw new Error('Failed to fetch news');
            }
            const data = await response.json();
            setNewsList(data.slice(0, 10)); // Get top 10 news
        } catch (err) {
            // Use mock data if API fails
            setNewsList([
                { id: 1, title: 'Welcome to Your News Site' },
                { id: 2, title: 'Getting Started' },
                { id: 3, title: 'Sample News Article' }
            ]);
        }
    };

    const toggleSection = (section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    return (
        <nav className="sidebar">
            <div className="sidebar-header">
                <h2>Menu</h2>
            </div>
            <ul className="sidebar-menu">
                {/* Latest News Section */}
                <li className="menu-section">
                    <div className="menu-section-header" onClick={() => toggleSection('news')}>
                        <span className="expand-icon">{expandedSections.news ? '▼' : '▶'}</span>
                        <Link to="/" className="menu-link-inline">Latest News</Link>
                    </div>
                    {expandedSections.news && (
                        <ul className="submenu-tree">
                            {newsList.map((article) => (
                                <li key={article.id}>
                                    <Link to={`/news/${article.id}`} className="submenu-link">
                                        {article.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}
                </li>

                {/* Developer Tools Section */}
                <li className="menu-section">
                    <div className="menu-section-header" onClick={() => toggleSection('tools')}>
                        <span className="expand-icon">{expandedSections.tools ? '▼' : '▶'}</span>
                        <Link to="/tools" className="menu-link-inline">Developer Tools</Link>
                    </div>
                    {expandedSections.tools && (
                        <ul className="submenu-tree">
                            <li>
                                <Link to="/timezone_converter" className="submenu-link">
                                    Timezone Converter
                                </Link>
                            </li>
                            <li>
                                <Link to="/json_format" className="submenu-link">
                                    JSON Format
                                </Link>
                            </li>
                            <li>
                                <Link to="/length_converter" className="submenu-link">
                                    Length Converter
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>

                {/* Admin Section - Only visible when logged in */}
                {isAuthenticated && (
                    <li className="menu-section">
                        <div className="menu-section-header">
                            <span className="expand-icon admin-icon">⚙</span>
                            <Link to="/admin" className="menu-link-inline admin-link">Admin</Link>
                        </div>
                    </li>
                )}

                {/* Login/Logout Section */}
                <li className="menu-section">
                    <div className="menu-section-header">
                        <span className="expand-icon auth-icon">👤</span>
                        {isAuthenticated ? (
                            <button onClick={logout} className="menu-link-inline logout-button">
                                Logout
                            </button>
                        ) : (
                            <Link to="/login" className="menu-link-inline login-link">
                                Login
                            </Link>
                        )}
                    </div>
                </li>
            </ul>
        </nav>
    );
}

export default Navbar;
